import React, { useEffect, useState, useRef } from "react";

const UnitOption = ({ onChange, rawselectedOption, indexval, cls }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("UNIT");
  const [options, setOptions] = useState([]);
  const [dropDirection, setDropDirection] = useState("down"); // 'up' or 'down'
  const dropdownRef = useRef(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    setOptions(["Item", "Hour", "Day", "Week", "Month", "None"]);
    if (rawselectedOption) setSelectedOption(rawselectedOption);
  }, [rawselectedOption]);

  const toggleDropdown = () => {
    if (!isOpen) {
      // Check space before opening
      const rect = wrapperRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      if (spaceBelow < 180 && spaceAbove > 180) {
        setDropDirection("up");
      } else {
        setDropDirection("down");
      }
    }
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    if (onChange) onChange(option, indexval);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className={`unit-dropdown-wrapper ${cls || ""}`}
      ref={wrapperRef}
    >
      <div
        className={`unit-toggle ${isOpen ? "active" : ""}`}
        onClick={toggleDropdown}
      >
        <span className="selected-option">{selectedOption}</span>
        <span className="arrow">{isOpen ? "▲" : "▼"}</span>
      </div>

      {isOpen && (
        <div
          ref={dropdownRef}
          className={`unit-dropdown dropdown-${dropDirection}`}
        >
          {options.map((option, idx) => (
            <div
              key={idx}
              className="unit-option"
              onClick={() => handleOptionClick(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UnitOption;
